













































// Vue
import { defineComponent, PropType, computed, ref } from '@vue/composition-api'

// components
import { Form, Input, Button, Icon, Radio } from '@/components/general'
import { Loading } from '@/components'

// models
import { InsuranceCompanyForm } from '@/models/config'

// services
import { InsuranceCompanyService } from '@/services/config'

// Vuelidate
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

// utils
import { alerts, loading } from '@/utils'

// constants
import { optionsStatus } from '@/constants'

export default defineComponent({
  name: 'InsuranceCompanyFormCreateEdit',
  components: {
    Form,
    Input,
    Button,
    Icon,
    Radio,
    Loading
  },
  props: {
    item: {
      type: Object as PropType<InsuranceCompanyForm>,
      required: true
    },
    idEdit: {
      type: Number as PropType<number>,
      default: null
    },
    action: {
      type: String as PropType<'save'|'update'>,
      required: true
    }
  },
  setup (props, { emit }) {
    const isLoading = ref(false)
    const rules = computed(() => ({
      item: {
        name: { required },
        is_active: { required }
      }
    }))
    const $v = useVuelidate(rules, { item: props.item })

    const save = async () => {
      $v.value.item.$touch()
      if (!$v.value.item.$invalid) {
        try {
          loading('show')
          if (props.action === 'save') {
            await InsuranceCompanyService.create(props.item)
          } else {
            await InsuranceCompanyService.update(props.idEdit, props.item)
          }
          loading('hide')
          alerts.success()
          emit('save-success')
        } catch (e) {
          alerts.error('ERROR.! No se pudo completar la operación')
          loading('hide')
        }
      } else {
        alerts.error('Debe completar todos los campos')
      }
    }
    return {
      save,
      $v,
      isLoading,
      optionsStatus
    }
  }
})
